export default "__VITE_ASSET__BQP4EEZd__"